<template>
  <div class="category-panel">
    <div class="category-seven">
      <swiper ref="mySwiper1" :options="swiperOptions" class="category-seven">
        <swiper-slide v-for="(ordertype, key) in all_business_types" :key="'module_' + key">
          <div>
            <div class="category-wrap" :class="{ active: ordertype._id == getSelectedBusinessType }">
              <a href="javascript:void(0)" @click="applyCategoryType(ordertype)">
                <div class="icon">
                  <svg class="filter-category" fill="none">
                    <use :xlink:href="'#' + getSVG(ordertype.name)" />
                  </svg>
                </div>
                <div class="content">
                  <h5>{{_T(ordertype.name)}}</h5>
                </div>
              </a>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      swiperOptions: {
        loop: false,
        slidesPerView: 7,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1366: {
            slidesPerView: 7,
            spaceBetween: 30,
          },
          1026: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
          320: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters(['_T', 'all_business_types', 'getSelectedBusinessType']),
  },
  methods: {
    getSVG(itemName) {
      let itemLowerCase = itemName.toLowerCase()
      return itemLowerCase.replace(' ', '_');
    },
    applyCategoryType(data) {
      this.$store.dispatch("setBusinessType", data)
    },
  },
}
</script>

<style lang="scss" scoped>
.category-panel {
  padding: $px20 $px60 0;
  margin-top: 0;
  border-top: $px1 solid $light-border;
  .category-wrap {
    text-align: center;
    position: relative;
    padding-bottom: $px15;
    .icon {
      height: $px40;
      display: flex;
      align-items: flex-start;
      .filter-category {
        height: $px40;
        margin: 0 auto;
      }
    }
    .content {
      height: $px38;
      display: flex;
      align-items: center;
      justify-content: center;
      h5 {
        font-weight: 600;
        font-size: $px16;
        line-height: $px19;
        letter-spacing: 0.02em;
        color: $light-font;
        margin-bottom: 0;
        text-transform: capitalize;
      }
    }
    &.active {
      .content {
        h5 {
          color: $color-primary;
        }
      }
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: $px3;
        background-color: $color-primary;
        left: 0;
      }
    }
  }
}

@media (max-width: 767px) {
  .category-panel {
    padding: 0 $px30;
    border-bottom: $px1 solid $light-border;
    margin: 0;
    border-top: none;
    &.pl-0 {
      padding-left: $px30 !important;
    }
    .category-wrap {
      padding-bottom: $px8;
    }
  }
}
@media (max-width: 575px) {
  .category-panel {
    padding: 0;
    .slick-next,
    .slick-prev {
      display: none !important;
    }
    .slick-list {
      margin-left: -$px5;
      margin-right: -$px5;
      .slick-slide {
        > div {
          margin-left: $px5;
          margin-right: $px5;
        }
      }
    }
    .category-wrap {
      .icon {
        height: $px64;
        width: $px64;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        border-radius: 100%;
        border: $px1 solid $light-border;
      }
      .content {
        h5 {
          font-weight: bold;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.02em;
          color: $font-color;
        }
      }
      &.active {
        .icon {
          border: $px2 solid $color-primary;
        }
        &:after {
          display: none;
        }
      }
    }
  }
}
</style>

// <style lang="scss">
// @media (max-width: 575px) {
//   .swiper-wrapper {
//     overflow-y: scroll !important;
//   }
// }
// </style>